module.exports = __webpack_public_path__ + "media/images/plans/img_party-wedding-0adabae6bed108e151dc9941894d5ac9.jpg";